<template>
  <div>
    <b-row>
      <b-col lg="6">
        <b-row>
          <mh-input mhClass="col-12" field="nPagesAnnexe" :table="courrier"> </mh-input>
        </b-row>
        <b-row>
          <mh-input mhClass="col-12" rows="30" labelColsLg="0" field="content" :table="courrier">
          </mh-input>
        </b-row>
      </b-col>
      <b-col lg="6">
        <b-button size="sm" @click="previewPdfPath()">Rafraîchir</b-button>
        <object class="mt-4" v-if="pdfPath" style="width: 100%; height: 1000px" :data="pdfPath"
          type="application/pdf"></object>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import courriers from "@/services/courriers";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Courrier",
  components: {
    MhInput,
  },
  props: {
    mandat: Object,
  },
  data() {
    return {
      warrant: {},
      courrier: {
        mandatID: this.$props.mandat.ID,
        nPagesAnnexe: {
          type: 'int',
          value: "2",
          label: "Nombre de pages en annexe"
        },
        content: {
          label: "Contenu du courrier",
          type: 'text',
          value: ''
        }
      },
      pdfPath: null,
      loaded: false,
    };
  },
  created() {
    this.warrant = this.$props.mandat;
    this.load();
  },
  methods: {
    load() {
      courriers
        .getPreviewHTML(34, this.courrier)
        .then((response) => {
          this.courrier.content = response.data.content;
          this.loaded = true;
          this.previewPdfPath();
        });
    },
    previewPdfPath() {
      courriers
        .getPreviewRCPDF(this.courrier)
        .then((response) => {
          this.pdfPath = "data:application/pdf;base64," + response.data;
        });
    },
  }
}
</script>

<style lang="scss" scoped>
</style>